import React, { useState, useEffect } from 'react';
import { useSafeState } from '../hooks/useSafeState';

const FlipCounter = ({ count = 0, isLoading = false }) => {
  console.log('FlipCounter rendered with:', { count, isLoading });
  const [displayCount, setDisplayCount] = useSafeState(count);
  const [animatingDigits, setAnimatingDigits] = useSafeState(new Set());

  useEffect(() => {
    if (count !== displayCount && !isLoading) {
      const oldFormatted = formatNumber(displayCount);
      const newFormatted = formatNumber(count);
      const oldDigits = oldFormatted.split('');
      const newDigits = newFormatted.split('');
      const maxLength = Math.max(oldDigits.length, newDigits.length);
      
      // Pad with spaces for comparison
      const paddedOld = oldDigits.concat(Array(maxLength - oldDigits.length).fill(' '));
      const paddedNew = newDigits.concat(Array(maxLength - newDigits.length).fill(' '));
      
      // Find which digits are changing
      const changingPositions = new Set();
      paddedOld.forEach((digit, index) => {
        if (digit !== paddedNew[index]) {
          changingPositions.add(index);
        }
      });
      
      setAnimatingDigits(changingPositions);
      
      // Update display after a brief delay for animation
      setTimeout(() => {
        setDisplayCount(count);
        setAnimatingDigits(new Set());
      }, 150);
    }
  }, [count, displayCount, isLoading]);

  const formatNumber = (num) => {
    try {
      return (num || 0).toLocaleString();
    } catch (error) {
      console.error('Error formatting number:', error);
      return String(num || 0);
    }
  };

  const formattedNumber = formatNumber(displayCount);
  const digits = formattedNumber.split('');

  // Don't render anything if still loading and no count
  if (isLoading && count === null) {
    return null;
  }

  return (
    <div className="flex items-center justify-center py-2">
      <div className="flex items-center text-sm text-black">
        <div className="flex items-center">
          {digits.map((digit, index) => (
            <span
              key={`${index}-${digit}`}
              className={`font-inter font-light transition-all duration-300 ${
                animatingDigits.has(index) ? 'animate-pulse' : ''
              }`}
            >
              <span
                className={`transition-transform duration-300 ${
                  animatingDigits.has(index) 
                    ? 'transform -translate-y-1 opacity-50' 
                    : 'transform translate-y-0 opacity-100'
                }`}
              >
                {digit}
              </span>
            </span>
          ))}
          <span className="ml-1 text-xs">layers. Zero regrets.</span>
        </div>
      </div>
    </div>
  );
};

export default FlipCounter;